export enum FilterTextTypes {
  CONTAINS = 'contains',
  EQUAL = 'equal',
  ENDS_WITH = 'endsWith',
  NOT_CONTAINS = 'notContains',
  NOT_EQUAL = 'notEqual',
  STARTS_WITH = 'startsWith'
}
